import { assoc, map, has, compose, filter, pluck } from "ramda"
import setErrors from "./setErrors.js"
import getMessage from "./getMessage"

export default (args) => {
  return (validationResult) => {
    const {
      fieldProps,
      form: { messages }
    } = args
    const { validators, expected } = validationResult
    const getErrorMessage = getMessage(messages)

    const errors = compose(
      pluck("errorMessage"),
      filter(has("errorMessage")),
      map((validator) => {
        if (!validator.expected) return { errorMessage: getErrorMessage(validator.ruleKeyPath), ruleKeyPath: validator.ruleKeyPath }
        return undefined
      })
    )(validators)

    const updatedFieldProps = compose(setErrors(errors), compose(assoc("expected", expected), assoc("validated", true)))
    return updatedFieldProps(fieldProps) // {fieldPath: Array(1), validated: true, expected: false, errors: Array(2)}
  }
}
